const CSS_FLEX_ALIGNED = {
  display: 'flex',
  alignItems: 'center'
}

const CONTAINER_MIN_HEIGHT = { minHeight: 'calc(100vh - 170px)' }

const CSS_FLEX_COLUMN = {
  display: 'flex',
  flexDirection: 'column'
}

const TRANSPARENT_BLACK = 'rgba(0,0,0,0.1)'

export {
  CSS_FLEX_ALIGNED,
  CONTAINER_MIN_HEIGHT,
  CSS_FLEX_COLUMN,
  TRANSPARENT_BLACK
}
